document.addEventListener('DOMContentLoaded', function() {

    var swiper_feature_product = new Swiper('.product-grid-slider', {
        loop: false,
        /*nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',*/
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: 20,
        mousewheel: {
            releaseOnEdges: true,
            sensitivity: 1,
            forceToAxis: true,
        },
        breakpoints: {
            989: {
                slidesPerView: 3.475,
                spaceBetween: 30
            },
            480: {
                slidesPerView: 2.475,
                spaceBetween: 10
            }
        }
    });

    document.querySelectorAll(".main-video").forEach(function(wrapper) {
        const video = wrapper.querySelector("video");
        const playBtn = wrapper.querySelector(".push_video_app");
        const pauseBtn = wrapper.querySelector(".play_video_app");
        // Play video
        playBtn.addEventListener("click", function () {
            video.play();
            playBtn.style.display = "none";
            pauseBtn.style.display = "flex";
        });
        // Pause video
        pauseBtn.addEventListener("click", function () {
            video.pause();
            pauseBtn.style.display = "none";
            playBtn.style.display = "flex";
        });
    });

    var swiper1 = new Swiper(".review-slider", {
        slidesPerView: 1,
        speed:1000,
         autoplay: {
            delay: 2000,
        },
        loop: true,
        spaceBetween: 22,
        breakpoints: {
            575: {
                slidesPerView: 2,
            },
            640: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
            1199: {
                slidesPerView: 3,
            },
        },
    });


    /* pack js */
    document.querySelectorAll('.pack-wrapper .pack-item').forEach(function(item) {

        item.addEventListener('click', function() {
        // 1️⃣ Remove "active" from all items
        document.querySelectorAll('.pack-wrapper .pack-item').forEach(function(el) {
            el.classList.remove('active');
            });
        // 2️⃣ Add "active" to clicked item
        this.classList.add('active');
        // 3️⃣ Get data-item value
        var qty = this.getAttribute('data-item');

        document.querySelectorAll('.build-items .circle-item').forEach(function (circle) {
          const index = parseInt(circle.getAttribute('data-index')) || 0;

          if (index <= qty) {
            circle.style.display = 'block';
          } else {
            circle.style.display = 'none';
          }

        });

        const filledLength = document.querySelectorAll('.build-items .circle-item:not(.empty)').length;
        if(qty == filledLength) {
            document.querySelectorAll('.biscuits-bundle-quantity .biscuits-bundle-quantity__button--plus').forEach(button => {
             button.setAttribute('disabled', 'disabled');
            });
        } else {
            document.querySelectorAll('.biscuits-bundle-quantity .biscuits-bundle-quantity__button--plus').forEach(button => {
                button.removeAttribute('disabled', 'disabled');
            });
        }

        });
    });


    const buildContainer = document.querySelector('.build-items');
    const productTracker = new Map();

    // 🔁 Reorder Function
    function reorderCircles() {

        const circles = Array.from(buildContainer.querySelectorAll('.circle-item'));

        const filled = circles.filter(circle => !circle.classList.contains('empty'));
        const empty = circles.filter(circle => circle.classList.contains('empty'));

        const ordered = [...filled, ...empty];

        ordered.forEach((circle, index) => {
            circle.setAttribute('data-index', index + 1);
            buildContainer.appendChild(circle);
        });

    }

    /* plus and minus both click */
    document.querySelectorAll('.biscuits-bundle-quantity__button').forEach(button => {
        button.addEventListener('click', function() {
        const filledLength = document.querySelectorAll('.build-items .circle-item:not(.empty)').length;
        const pack_val = document.querySelector('.pack-wrapper .pack-item.active')?.getAttribute('data-item');
        if(pack_val == filledLength) {
            document.querySelectorAll('.biscuits-bundle-quantity .biscuits-bundle-quantity__button--plus').forEach(button => {
                button.setAttribute('disabled', 'disabled');
            });
        } else {
            document.querySelectorAll('.biscuits-bundle-quantity .biscuits-bundle-quantity__button--plus').forEach(button => {
                button.removeAttribute('disabled', 'disabled');
            });
        }
        });
    });

    // ➕ PLUS BUTTON
    document.querySelectorAll('.biscuits-bundle-quantity__button--plus')
    .forEach(button => {

        button.onclick = function() {

        const container = this.closest('.biscuits-bundle-item__container');
        const img = container.querySelector('.biscuits-bundle-item__image img');
        const img_src = img ? img.getAttribute('src') : null;

        if (!img_src) return;

        let count = productTracker.get(container) || 0;

        const emptyCircle = buildContainer.querySelector('.circle-item.empty');
        if (!emptyCircle) return;

        const circleImg = emptyCircle.querySelector('img');
        circleImg.setAttribute('src', img_src);
        emptyCircle.classList.remove('empty');

        count++;
        productTracker.set(container, count);

        reorderCircles(); // 🔁 important
        };

    });


    // ➖ MINUS BUTTON
    document.querySelectorAll('.biscuits-bundle-quantity__button--minus')
    .forEach(button => {

        button.onclick = function() {

        const container = this.closest('.biscuits-bundle-item__container');
        let count = productTracker.get(container) || 0;
        if (count <= 0) return;

        const img = container.querySelector('.biscuits-bundle-item__image img');
        const img_src = img ? img.getAttribute('src') : null;

        const filledCircles = Array.from(
            buildContainer.querySelectorAll('.circle-item')
        ).filter(circle =>
            circle.querySelector('img').getAttribute('src') === img_src
        );

        if (filledCircles.length === 0) return;

        const lastCircle = filledCircles[filledCircles.length - 1];
        const circleImg = lastCircle.querySelector('img');

        circleImg.setAttribute('src', '');
        lastCircle.classList.add('empty');

        count--;
        productTracker.set(container, count);

        reorderCircles(); // 🔁 important
        };

    });


    // /* Bundle Add To Cart Code */
    var bundleBtn = document.querySelector('.cookie_bundle_btn #cookie_bundle_drawer');

    if (bundleBtn) {
        bundleBtn.addEventListener('click', function (e) {
            e.preventDefault();

            var items = [];
            var products = document.querySelectorAll('.cookie_bundle_pro .cookie_bundlePro_box');

            products.forEach(function (product) {
                var variantId = product.getAttribute('id');
                if (variantId) {
                items.push({
                    id: variantId,
                    quantity: 1
                });
                }
            });

            if (items.length === 0) return;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            })
            .then(res => res.json())
            .then(function () {

                /* ===== Drawer Update Logic ===== */
                var cartDrawer = document.querySelector('cart-drawer, .drawer__inner'); // updated selector
                var emptyDrawer = document.querySelector('.drawer__inner-empty');
                var clearBtn = document.querySelector('.cart_item_clear_btn');
                var drawer = document.querySelector('.drawer');
                var drawerHeader = document.querySelector('.drawer__header');

                if (cartDrawer) cartDrawer.classList.remove('is-empty');
                if (emptyDrawer) emptyDrawer.style.display = 'none';
                if (clearBtn) clearBtn.classList.add('active');

                /* Reload Cart Drawer Section Dynamically */
                fetch(window.location.href)
                .then(res => res.text())
                .then(html => {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');

                    // Try to find new drawer content
                    var newCart = doc.querySelector('cart-drawer, .drawer__inner'); // match current theme
                    if (newCart && cartDrawer) {
                    cartDrawer.innerHTML = newCart.innerHTML;
                    }
                });

                setTimeout(function () {
                if (clearBtn) clearBtn.classList.add('active');
                if (drawer) drawer.classList.add('active', 'animate');

                if (drawerHeader) {
                        drawerHeader.addEventListener('click', function (e) {
                        e.preventDefault();
                    });
                }
                }, 1000);

            })
            .catch(function (error) {
                console.error('Error adding to cart:', error);
            });
        });
    }


});









document.addEventListener('DOMContentLoaded', function() {
    let selectedPack = 6;

    const packButtons = document.querySelectorAll(".pack-item");
    const products = document.querySelectorAll(".product");
    const warning = document.getElementById("warning");
    const circles = document.querySelectorAll(".circle-item");

    /* ---------------- HELPERS ---------------- */

    function getTotalFilled() {
        let total = 0;
        circles.forEach(circle => {
            if (!circle.classList.contains("empty") && circle.style.display !== "none") {
                total++;
            }
        });
        return total;
    }

    function getFirstEmptyCircle() {
        for (let circle of circles) {
            if (circle.classList.contains("empty") && circle.style.display !== "none") {
                return circle;
            }
        }
        return null;
    }

    function togglePlusButtons(disable) {
        document.querySelectorAll(".qty-btn.plus").forEach(btn => {
            disable
                ? btn.classList.add("disabled")
                : btn.classList.remove("disabled");
        });
    }

    /* ---------------- PACK BUTTON ---------------- */

    packButtons.forEach(btn => {
        btn.onclick = function () {

            packButtons.forEach(b => b.classList.remove("active"));
            this.classList.add("active");

            selectedPack = parseInt(this.dataset.item);

            circles.forEach((circle, index) => {
                circle.style.display = (index < selectedPack) ? "flex" : "none";
            });

            adjustAfterPackChange();
            compactCircles();
            checkStatus();
        };
    });

    /* ---------------- PRODUCT QTY ---------------- */

    products.forEach(product => {

        const plus = product.querySelector(".plus");
        const minus = product.querySelector(".minus");
        const qtyEl = product.querySelector(".qty");
        const img = product.dataset.img;

        plus.onclick = function () {

            if (getTotalFilled() >= selectedPack) return;

            const emptyCircle = getFirstEmptyCircle();
            if (!emptyCircle) return;

            emptyCircle.classList.remove("empty");
            emptyCircle.querySelector("img").src = img;

            qtyEl.textContent = parseInt(qtyEl.textContent) + 1;

            checkStatus();
        };

        minus.onclick = function () {

            let current = parseInt(qtyEl.textContent);
            if (current <= 0) return;

            // remove last matching circle
            for (let i = circles.length - 1; i >= 0; i--) {
                let circle = circles[i];

                if (
                    !circle.classList.contains("empty") &&
                    circle.querySelector("img").getAttribute("src") === img
                ) {
                    circle.classList.add("empty");
                    circle.querySelector("img").src = "";
                    break;
                }
            }

            qtyEl.textContent = current - 1;

            compactCircles();
            checkStatus();
        };
    });

    /* ---------------- REMOVE BUTTON INSIDE CIRCLE ---------------- */

    circles.forEach(circle => {

        const removeBtn = circle.querySelector(".remove-product");
        if (!removeBtn) return;

        removeBtn.onclick = function () {

            if (circle.classList.contains("empty")) return;

            const imgSrc = circle.querySelector("img").getAttribute("src");

            products.forEach(product => {
                if (product.dataset.img === imgSrc) {
                    const qtyEl = product.querySelector(".qty");
                    let current = parseInt(qtyEl.textContent);
                    if (current > 0) qtyEl.textContent = current - 1;
                }
            });

            circle.classList.add("empty");
            circle.querySelector("img").src = "";

            compactCircles();
            checkStatus();
        };
    });

    /* ---------------- PACK CHANGE ADJUST ---------------- */

    function adjustAfterPackChange() {

        let filled = [];

        circles.forEach(circle => {
            if (!circle.classList.contains("empty")) {
                filled.push(circle);
            }
        });

        if (filled.length > selectedPack) {

            for (let i = selectedPack; i < filled.length; i++) {

                let circle = filled[i];
                const imgSrc = circle.querySelector("img").getAttribute("src");

                products.forEach(product => {
                    if (product.dataset.img === imgSrc) {
                        const qtyEl = product.querySelector(".qty");
                        let current = parseInt(qtyEl.textContent);
                        if (current > 0) qtyEl.textContent = current - 1;
                    }
                });

                circle.classList.add("empty");
                circle.querySelector("img").src = "";
            }
        }
    }

    /* ---------------- CIRCLES COMPACTING ---------------- */

    function compactCircles() {
        // Collect all filled circles' images
        const filledImgs = [];
        circles.forEach(circle => {
            if (!circle.classList.contains("empty") && circle.style.display !== "none") {
                filledImgs.push(circle.querySelector("img").getAttribute("src"));
            }
        });

        // Mark all circles empty
        circles.forEach(circle => {
            circle.classList.add("empty");
            circle.querySelector("img").src = "";
        });

        // Fill circles again compactly
        for (let i = 0; i < filledImgs.length && i < selectedPack; i++) {
            circles[i].classList.remove("empty");
            circles[i].querySelector("img").src = filledImgs[i];
        }
    }

    /* ---------------- STATUS CHECK ---------------- */

    function checkStatus() {
    
        let total = getTotalFilled();

        if (total < selectedPack) {
            warning.textContent = `Please select minimum ${selectedPack} cookies`;
            togglePlusButtons(false);
        } else {
            warning.textContent = "";
            togglePlusButtons(true);
        }
    }

        // Prevent duplicate binding
    const addToCartBtn = document.querySelector(".template-suffix-bundle .product--add-to-cart-button");

    if (addToCartBtn && !addToCartBtn.dataset.listenerAdded) {

        addToCartBtn.dataset.listenerAdded = "true";

        addToCartBtn.addEventListener("click", function (e) {

            e.preventDefault();

            // 🚫 Prevent multiple clicks
            if (addToCartBtn.classList.contains("loading")) return;
            addToCartBtn.classList.add("loading");
            addToCartBtn.disabled = true;

            const products = [];
            const productElements = document.querySelectorAll(".products .product");

            const sellingPlanEl = document.querySelector('.appstle_sub_widget');
            const selling_id = sellingPlanEl 
                ? sellingPlanEl.getAttribute('data-selected-selling-plan') 
                : null;

            productElements.forEach(function (product) {

                const variantId = product.getAttribute("data-variant_id");
                const qtyInput = product.querySelector(".qty");

                let qty = 0;

                if (qtyInput && qtyInput.value) {
                    qty = parseInt(qtyInput.value);
                } else if (qtyInput) {
                    qty = parseInt(qtyInput.textContent.trim());
                }

                if (variantId && qty > 0) {

                    let itemData = {
                        id: variantId,
                        quantity: qty
                    };

                    if (selling_id && !isNaN(selling_id)) {
                        itemData.selling_plan = selling_id;
                    }

                    products.push(itemData);
                }

            });

            if (products.length === 0) {
                addToCartBtn.classList.remove("loading");
                addToCartBtn.disabled = false;
                return;
            }

            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    items: products
                })
            })
            .then(response => response.json())
            .then(() => {

                // /* ===== Drawer Update Logic ===== */

                const cartDrawer = document.querySelector('cart-drawer, .drawer__inner');
                const emptyDrawer = document.querySelector('.drawer__inner-empty');
                const clearBtn = document.querySelector('.cart_item_clear_btn');
                const drawer = document.querySelector('.drawer');

                if (cartDrawer) cartDrawer.classList.remove('is-empty');
                if (emptyDrawer) emptyDrawer.style.display = 'none';
                if (clearBtn) clearBtn.classList.add('active');

                // Reload only cart section (Better than full page)
                fetch('/?section_id=cart-drawer')
                .then(res => res.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newCart = doc.querySelector('cart-drawer, .drawer__inner');

                    if (newCart && cartDrawer) {
                        cartDrawer.innerHTML = newCart.innerHTML;
                    }
                });

                setTimeout(() => {
                    if (drawer) drawer.classList.add('active', 'animate');
                }, 500);
                // window.location.href="/checkout";

            })
            .catch(error => {
                console.error("Error:", error);
            })
            .finally(() => {
                // ✅ Re-enable button safely
                addToCartBtn.classList.remove("loading");
                addToCartBtn.disabled = false;
            });

        });
    }

});

// Zip Code
// document.addEventListener("DOMContentLoaded", function () {

//     /* ===============================
//        TAB CLICK FUNCTIONALITY
//     =============================== */
//     var tabs = document.querySelectorAll('.ship-to-tab');
//     var pincodeSection = document.querySelector('.local-delivery-pincode');

//     tabs.forEach(function (tabBtn) {
//         tabBtn.addEventListener('click', function () {

//             tabs.forEach(function (btn) {
//                 btn.classList.remove('active');
//             });

//             this.classList.add('active');

//             var tab = this.getAttribute('data-tab');

//             if (tab === 'local-delivery') {
//                 pincodeSection && pincodeSection.classList.remove('hide', 'hidden');
//             } else {
//                 pincodeSection && pincodeSection.classList.add('hide', 'hidden');
//             }
//         });
//     });


//     /* ===============================
//        ZIP CODE INPUT (ONLY NUMBERS)
//     =============================== */
//     var zipInput = document.getElementById('zip-code-value');

//     if (zipInput) {
//         zipInput.addEventListener('input', function () {
//             this.value = this.value.replace(/[^0-9]/g, '');
//         });

//         zipInput.addEventListener('click', hideMessages);
//         zipInput.addEventListener('keyup', hideMessages);
//     }

//     function hideMessages() {
//         var success = document.querySelector('.shipping-success');
//         var unsuccess = document.querySelector('.shipping-unsuccess');

//         success && success.classList.add('hide', 'hidden');
//         unsuccess && unsuccess.classList.add('hide', 'hidden');
//     }


//     /* ===============================
//        DELIVERY VALIDATION BUTTON
//     =============================== */
//     var submitBtn = document.getElementById('delivery-validation-submit');

//     if (submitBtn) {
//         submitBtn.addEventListener('click', function (e) {

//             e.preventDefault();

//             var zipCode = zipInput ? zipInput.value.trim() : '';

//             var shippingCodeElement = document.querySelector('.shipping-code');
//             var validCodesText = shippingCodeElement ? shippingCodeElement.textContent : '';

//             var validCodes = validCodesText.split(',').map(function (item) {
//                 return item.trim();
//             });

//             if (zipCode.length < 4) {
//                 // alert('Please enter minimum 4 digit numeric zip code');
//                 return;
//             }

//             var success = document.querySelector('.shipping-success');
//             var unsuccess = document.querySelector('.shipping-unsuccess');

//             if (validCodes.includes(zipCode)) {
//                 success && success.classList.remove('hide', 'hidden');
//                 unsuccess && unsuccess.classList.add('hide', 'hidden');
//             } else {
//                 unsuccess && unsuccess.classList.remove('hide', 'hidden');
//                 success && success.classList.add('hide', 'hidden');
//             }

//         });
//     }

// });

document.addEventListener("DOMContentLoaded", function () {

    function removeBracketText(selector) {
        const elements = document.querySelectorAll(selector);

        elements.forEach(function (el) {
            let text = el.textContent;
            let cleanedText = text.replace(/\([^)]*\)/g, "").trim();
            el.textContent = cleanedText;
        });
    }

    removeBracketText(".featured-collections-block .product-grid-block .card__content .card__heading a");
    removeBracketText(".featured-collections-block .product-grid-slider .grid__items .card__heading a");
    removeBracketText("div#ProductGridContainer .card__content .card__heading a");
    removeBracketText(".product-section .product-single .product .pdp-bundle-title");

    const wrappers = document.querySelectorAll(".featured-collections-block .product-card-wrapper");
    wrappers.forEach(function(wrapper) {
        const mainLink = wrapper.querySelector(".card__heading a");
        if (!mainLink) return;

        let text = mainLink.textContent.trim();
        let handle = text
            .toLowerCase()
            .replace(/\([^)]*\)/g, "")
            .trim()
            .replace(/\s+/g, "-");

        let newUrl = "/products/build-your-box?handle=" + handle;

        const allLinks = wrapper.querySelectorAll("a");
        allLinks.forEach(function(el) {
            el.setAttribute("href", newUrl);
        });

    });


   (function() {
        const urlParams = new URLSearchParams(window.location.search);
        const handle = urlParams.get("handle");
        window.__plusClickedHandles = window.__plusClickedHandles || {};
        if (!handle || window.__plusClickedHandles[handle]) return;

        const products = document.querySelectorAll(".template-suffix-bundle .product-single-wrapper .products .product");

        for (const product of products) {
            const productHandle = product.getAttribute("data-handle");

            if (productHandle === handle) {
                const plusBtn = product.querySelector(".qty-control .qty-btn.plus");

                if (plusBtn) {
                    window.__plusClickedHandles[handle] = true;

                    setTimeout(() => {
                        plusBtn.click();
                    }, 1000);
                    break;
                }
            }
        }
    })();

});


// ---- Real cart item count ----
// The checkout minimum below used to read the number from the header cart
// bubble, which doesn't exist / isn't updated after a Build Your Box add.
// That made it think the cart had 0 items and kept checkout disabled.
// Now we read the actual count from /cart.js and refresh it whenever
// anything changes the cart.
window.__cartQty = 0;

function refreshCartQty() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (c) { window.__cartQty = c.item_count; })
    .catch(function () {});
}
refreshCartQty();

(function () {
  var origFetch = window.fetch;
  window.fetch = function () {
    var p = origFetch.apply(this, arguments);
    var url = String((arguments[0] && arguments[0].url) || arguments[0]);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refreshCartQty, 300); }).catch(function () {});
    }
    return p;
  };
})();


setInterval(function () {

  // Fix: the pack-block markup renders twice in the liquid (mobile top pack +
  // main form), so there are TWO .pack-item[data-item="12"] elements. Using
  // querySelector() grabbed the first one, which never gets the "active" class,
  // so the price update below never fired. Checking all of them with .some()
  // fixes that.
  var packItem12Active = Array.from(
    document.querySelectorAll('.pack-item[data-item="12"]')
  ).some(function (el) {
    return el.classList.contains('active');
  });

  var packItem8Active = Array.from(
    document.querySelectorAll('.pack-item[data-item="8"]')
  ).some(function (el) {
    return el.classList.contains('active');
  });

  // ---- Mountain Chalet capacity cap: that box only fits 8 cookies max, so
  // hide the 12-pack option and reveal the 8-pack option while it's checked.
  // If the shopper already had 12-pack selected, fall back to 6-pack so
  // they're never left over the box's real capacity.
  var chaletCheckbox = document.getElementById('mountain-chalet-checkbox');
  var chaletChecked = !!(chaletCheckbox && chaletCheckbox.checked);

  document.querySelectorAll('.pack-item[data-item="12"]').forEach(function (el) {
    el.style.display = chaletChecked ? 'none' : '';
  });
  document.querySelectorAll('.pack-item[data-item="8"]').forEach(function (el) {
    el.style.display = chaletChecked ? '' : 'none';
  });

  if (chaletChecked && packItem12Active) {
    document.querySelectorAll('.pack-item[data-item="6"]').forEach(function (el) {
      el.click();
    });
  }
  if (!chaletChecked && packItem8Active) {
    document.querySelectorAll('.pack-item[data-item="6"]').forEach(function (el) {
      el.click();
    });
  }

  var prices = document.querySelectorAll(
    '.appstle_one_time_price_wrapper .appstle_subscription_amount, \
     .appstle_subscription_amount_wrapper .appstle_subscription_amount, \
     .appstle_subscription_amount_wrapper .appstle_subscription_compare_amount'
  );

  // 6-pack base price -> 12-pack / 8-pack target price (not flat multiples)
  var SIX_PACK_PRICE = 55;
  var EIGHT_PACK_PRICE = 70;
  var TWELVE_PACK_PRICE = 90;

  var packMultiplier = 1;
  if (packItem12Active) {
    packMultiplier = TWELVE_PACK_PRICE / SIX_PACK_PRICE;
  } else if (packItem8Active) {
    packMultiplier = EIGHT_PACK_PRICE / SIX_PACK_PRICE;
  }

  prices.forEach(function(priceEl){

    let originalPrice = priceEl.getAttribute("data-original-price");

    if (!originalPrice) {
      originalPrice = parseFloat(priceEl.innerText.replace(/[^0-9.]/g, ""));
      priceEl.setAttribute("data-original-price", originalPrice);
    } else {
      originalPrice = parseFloat(originalPrice);
    }

    let finalPrice = originalPrice * packMultiplier;

    priceEl.innerText = "$" + finalPrice.toFixed(2);

  });

  // Use the real cart count (see refreshCartQty above)
  let cartQTY = window.__cartQty || 0;

  let drawerBTN = document.querySelector('.drawer__footer .cart__ctas button');
  let pageCartBtn = document.querySelector('#main-cart-footer .cart__footer .cart__blocks .cart__checkout-button');
  let pageCartBtnOther = document.querySelector('#main-cart-footer .cart__footer .cart__blocks #dynamic-checkout-cart');

  if (cartQTY < 6) {
    if(drawerBTN) drawerBTN.disabled = true;
    if(pageCartBtn) pageCartBtn.disabled = true;
    if(pageCartBtnOther) pageCartBtnOther.setAttribute("disabled", "true");
  } else {
    if(drawerBTN) drawerBTN.disabled = false;
    if(pageCartBtn) pageCartBtn.disabled = false;
    if(pageCartBtnOther) pageCartBtnOther.removeAttribute("disabled");
  }

}, 250);
